module.exports = __webpack_public_path__ + "img/Unidad2-2.fbc1351a.png";